import { ProposalFormData, ProposalFormDataLineItem } from 'types/proposal';
import { getGeneratedInitialLineItem } from './utils';

export const initialProposalFormDataValues: ProposalFormData = {
    title: '',
    appointmentId: '',
    contractorId: '',
    lineItems: [getGeneratedInitialLineItem()],
};
